module.exports = __webpack_public_path__ + "res/28-img_reward_t.3d5c7da8d7ff5dd875fe740ca7a018f5.png";